"use client";

import { useScopedI18n } from "@/messages/client";
import { Table } from "@tanstack/react-table";
import {
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

export default function Pagination<T>({ table }: { table: Table<T> }) {
  const t = useScopedI18n("选型器");

  const { pageIndex, pageSize } = table.getState().pagination;

  const prePage = table.getPrePaginationRowModel().rows;

  const current =
    pageIndex * pageSize + 1 > table.options.data.length
      ? table.options.data.length
      : pageIndex * pageSize + 1;

  const currentTotal =
    (pageIndex + 1) * pageSize > prePage.length
      ? prePage.length
      : (pageIndex + 1) * pageSize;

  return (
    <div className="flex h-12 w-full items-center justify-end border-b border-l border-r border-[#babfc7] md:px-5 px-2">
      <span className="mx-4 select-none space-x-1 text-xs">
        {t<any, any>("{current} 到 {count} 共 {total}", {
          current,
          count: currentTotal,
          total: prePage.length,
        })}
      </span>
      <span className="mx-4 flex items-center space-x-4 text-[#181d1f]">
        <button
          className="cursor-pointer outline-none transition-colors duration-200 hover:text-primary"
          onClick={() => {
            table.setPageIndex(0);
          }}
          disabled={!table.getCanPreviousPage()}>
          <ChevronFirst size={16} />
        </button>
        <button
          className="cursor-pointer outline-none transition-colors duration-200 hover:text-primary"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}>
          <ChevronLeft size={16} />
        </button>
        <div className="select-none space-x-1 text-xs">
          {t<any, any>("第{page}页，共{total}页", {
            page: pageIndex + 1,
            total: table.getPageCount(),
          })}
        </div>
        <button
          className="cursor-pointer outline-none transition-colors duration-200 hover:text-primary"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}>
          <ChevronRight size={16} />
        </button>
        <button
          className="cursor-pointer outline-none transition-colors duration-200 hover:text-primary"
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}>
          <ChevronLast size={16} />
        </button>
      </span>
    </div>
  );
}
